import React from 'react';
import * as S from './styles';

function Paragraph({children, colors, italic}) {
  return <S.Paragraphs colors= {colors} italic= {italic}>
    {children}
  </S.Paragraphs>;
}

export default Paragraph;